module.exports = __webpack_public_path__ + "static/media/swatchbook.bc371222.svg";